<template>
    <b-modal v-model="showModal" :title="isEditing ? 'Editar Banner' : 'Crear Banner'" size="lg">
        <label for="title">Vista previa</label>
        <Banner :title="banner.title" :description="banner.description" :bg="banner.bg" :icon="banner.icon"
            :cta="banner.cta" :ctaHref="banner.ctaHref" />
        <b-form class="mt-3">
            <b-form-group id="title" label="Título" label-for="title">
                <b-form-input id="title" v-model="banner.title" type="text" required></b-form-input>
            </b-form-group>
            <b-form-group id="description" label="Descripción" label-for="description">
                <b-form-input id="description" v-model="banner.description" type="text" required></b-form-input>
            </b-form-group>
            <b-form-group id="bg" label="Color de fondo" label-for="bg">
                <div class="color-options">
                    <div v-for="color in colors" :key="color" class="color-options__item"
                        :class="{ active: banner.bg === color }"
                        :style="{ background: `linear-gradient(to right, ${color}, color-mix(in srgb, ${color} 80%, white))` }"
                        @click="banner.bg = color">
                    </div>
                </div>
            </b-form-group>
            <label for="icon">Icono</label>
            <div class="icon-options">
                <div v-for="icon in icons" :key="icon" class="icon-options__item"
                    :class="{ active: banner.icon === icon }" @click="banner.icon = icon">
                    <div class="material-icons">{{ icon }}</div>
                </div>
            </div>
            <b-form-group id="cta" label="Texto del botón" label-for="cta">
                <b-form-input id="cta" v-model="banner.cta" type="text" required></b-form-input>
            </b-form-group>
            <b-form-group id="ctaHref" label="Enlace del botón" label-for="ctaHref">
                <b-form-input id="ctaHref" v-model="banner.ctaHref" type="text" required></b-form-input>
            </b-form-group>
        </b-form>
        <template #modal-footer>
            <b-button variant="secondary" @click="hide">Cancelar</b-button>
            <b-button variant="primary" @click="onSubmit">{{ isEditing ? 'Actualizar' : 'Guardar' }}</b-button>
        </template>
    </b-modal>
</template>

<script>
import Banner from '@/components/dashboard/Banner.vue';
export default {
    name: 'BannerForm',
    components: {
        Banner
    },
    data() {
        return {
            showModal: false,
            isEditing: false,
            icons: [
                'store',
                'motorcycle',
                'location_on',
                'shopping_cart',
                'local_shipping',
                'support',
                'settings',
                'info',
                'local_offer',
                'campaign',
                'new_releases',
                'celebration',
                'star',
                'bolt',
                'rocket_launch',
                'trending_up',
                'inventory_2',
                'warehouse',
                'map',
                'route',
                'timer',
                'schedule',
                'notifications',
                'percent',
                'payments',
                'handshake',
                'group',
                'verified',
                'security',
                'speed',
                'eco',
                'card_giftcard',
                'redeem',
                'loyalty',
                'discount',
                'savings',
                'account_balance_wallet',
                'credit_card',
                'receipt_long',
                'qr_code_scanner',
                'smartphone',
                'email',
                'sms',
                'chat',
                'thumb_up',
                'favorite',
                'workspace_premium',
                'military_tech',
                'emoji_events',
                'flag',
                'lightbulb',
                'build',
                'extension',
                'public',
                'language',
                'flight',
                'directions_car',
                'directions_bike',
                'pedal_bike',
                'airport_shuttle',
                'moving',
                'home',
                'storefront',
                'domain',
                'business_center',
            ],
            colors: [
                // Colores del tema
                '#495057',
                '#939393',
                '#3DF9DE',
                '#00C5AC',
                '#F46A6A',
                '#50A5F1',
                '#34C38F',
                '#F1B44C',
                // Paleta extendida
                '#fb542b',
                '#e63946',
                '#d62828',
                '#f77f00',
                '#fcbf49',
                '#2a9d8f',
                '#264653',
                '#1d3557',
                '#457b9d',
                '#0077b6',
                '#023e8a',
                '#6a0572',
                '#7209b7',
                '#560bad',
                '#3a0ca3',
                '#4361ee',
                '#4cc9f0',
                '#06d6a0',
                '#2d6a4f',
                '#386641',
                '#212529',
                '#495057',
                '#6c757d',
            ],
            banner: this.getDefaultBanner()
        }
    },
    methods: {
        getDefaultBanner() {
            return {
                title: 'Nuevo Banner',
                description: 'Descripción del banner',
                bg: '#fb542b',
                icon: 'store',
                cta: '',
                ctaHref: '',
                active: true
            }
        },
        onSubmit() {
            this.$emit('submit', { ...this.banner });
        },
        show(item) {
            if (item) {
                this.isEditing = true;
                this.banner = { ...item };
            } else {
                this.isEditing = false;
                this.banner = this.getDefaultBanner();
            }
            this.showModal = true;
        },
        hide() {
            this.showModal = false;
        }
    }
}
</script>

<style scoped>
.color-options {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-start;
}

.color-options__item {
    width: 80px;
    height: 40px;
    border-radius: 5px;
    cursor: pointer;
    margin: 5px;
    border: 2px solid #fff;
}

.color-options__item:hover {
    transform: scale(1.1);
}

.color-options__item.active {
    border: 2px solid #0259cc;
}

.icon-options {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-start;
}

.icon-options__item {
    width: 40px;
    height: 40px;
    border-radius: 5px;
    cursor: pointer;
    margin: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    background-color: #f8f9fa;
    border: 2px solid #e0e0e0;
}

.icon-options__item:hover {
    transform: scale(1.1);
}

.icon-options__item.active {
    border: 2px solid #0259cc;
}
</style>
